import { render, staticRenderFns } from "./NewJobHistoryDetails.vue?vue&type=template&id=a62ad1de&scoped=true&"
import script from "./NewJobHistoryDetails.vue?vue&type=script&lang=ts&"
export * from "./NewJobHistoryDetails.vue?vue&type=script&lang=ts&"
import style0 from "./NewJobHistoryDetails.vue?vue&type=style&index=0&id=a62ad1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62ad1de",
  null
  
)

export default component.exports